import { createSlice } from '@reduxjs/toolkit';

const stateSlice = createSlice({
	name: 'lastActionsPanel/state',
	initialState: false,
	reducers: {
		toggleLastActionsPanel: state => !state,
		openLastActionsPanel: state => true,
		closeLastActionsPanel: state => false
	}
});

export const { toggleLastActionsPanel, openLastActionsPanel, closeLastActionsPanel } = stateSlice.actions;

export default stateSlice.reducer;
